// extracted by mini-css-extract-plugin
module.exports = {"notfoundMain":"Notfound_notfoundMain__10qx_","notfoundTitle":"Notfound_notfoundTitle__2gAX3","notfoundDesc":"Notfound_notfoundDesc__2RI04"};